export interface HouseContentsCalculatorFormValues {
  people?: number;
  rooms?: number;
  standard?: StandardOptions;
  suggestedInsuranceAmount?: number;
}

export enum StandardOptions {
  STANDARD_NOT_SELECTED = "",
  STANDARD_VERY_HIGH = "VERY_HIGH",
  STANDARD_HIGH = "HIGH",
  STANDARD_MEDIUM_HIGH = "MEDIUM_HIGH",
  STANDARD_MEDIUM = "MEDIUM",
  STANDARD_MEDIUM_LOW = "MEDIUM_LOW",
  STANDARD_LOW = "LOW",
}
